var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3854 5.29011C12.7663 5.5058 13 5.89852 13 6.32284V11.8008C13 12.4631 12.4404 13 11.75 13H10.5C9.80963 13 9.25 12.4631 9.25 11.8008V9.40229C9.25 8.74002 8.69037 8.20307 8 8.20307C7.30963 8.20307 6.75 8.74002 6.75 9.40229V11.8008C6.75 12.4631 6.19036 13 5.5 13H4.25C3.55964 13 3 12.4631 3 11.8008V6.32284C3 5.89852 3.23372 5.5058 3.61459 5.29011L7.36456 3.16649C7.75663 2.9445 8.24337 2.9445 8.63544 3.16649L12.3854 5.29011Z",
    stroke: "#272727",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoHome);
export default __webpack_public_path__ + "static/media/go-home.ba68a17bc993ad318dfc12f5466fa3f1.svg";
export { ForwardRef as ReactComponent };